import { Component, Input, OnInit } from '@angular/core';
import { CoreService, ProleisObject } from 'proleis-rest-client';
import { RedirectService } from '../../../services/redirect.service';
import { MatDialog } from '@angular/material/dialog';
import { ChainDetailsDialogComponent } from '../chain-details-dialog/chain-details-dialog.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-chain-info',
  templateUrl: './chain-info.component.html',
  styleUrls: ['./chain-info.component.scss'],
})
export class ChainInfoComponent implements OnInit {
  @Input()
  links: string;

  @Input()
  direction: string;

  linkObject: Observable<ProleisObject>;

  mode: 'single' | 'multiple';

  constructor(
    private cs: CoreService,
    private rs: RedirectService,
    private dialog: MatDialog,
  ) {}

  ngOnInit() {
    const count = this.links.split(',').length;
    if (count === 1) {
      this.mode = 'single';
    } else if (count > 1) {
      this.mode = 'multiple';
    }
  }

  redirect(id: string) {
    this.rs.redirectToInfoPanel(id);
  }

  openDetailsDialog(id: string) {
    this.dialog.open(ChainDetailsDialogComponent, {
      data: { ids: this.links, direction: this.direction },
    });
  }

  public fetchLink() {
    this.linkObject = this.cs.getObjectById<ProleisObject>(this.links);
  }
}
